// docs: https://github.com/altostra/type-validations#readme
import { arrayOf, maybe, objectOf } from "@altostra/type-validations";
import { any, number, string } from "@altostra/type-validations/lib/primitives";

import type { PlaywrightScanA11yResult, PlaywrightScanA11yViolation } from "./types";

export const isPlaywrightScanA11yResult = objectOf<PlaywrightScanA11yResult>({
  status: number,
  violations: maybe(
    arrayOf<PlaywrightScanA11yViolation>(
      objectOf({
        id: string,
        impact: any,
        help: string,
        helpUrl: string,
        nodes: arrayOf(
          objectOf({
            html: string,
            impact: any,
            target: arrayOf(string),
          })
        ),
      })
    )
  ),
  error_message: maybe(string),
});
